import { type FC } from "react";
import { Select, type SelectOptionType } from "@onshopfront/components";

interface Props {
    options: Array<SelectOptionType<string>>;
    value: string;
    onChange: (value: string) => void;
}

export const StyleSelect: FC<Props> = ({
    options,
    value,
    onChange,
}) => {
    const selected = options.find(option => option.value === value);

    return (
        <Select
            options={options}
            value={selected ?? options[0]}
            onChange={(option: SelectOptionType<string>) => {
                onChange(option.value);
            }}
        />
    );
};
